#@import Backbone
#@import CountdownTimer.Helpers
#@export CountdownTimer.View

DEFAULT_EL = '.limited-time > .counter li.countdown-timer'

window.CountdownTimer ?= {}

CountdownTimer.View = Backbone.View.extend
  UPDATE_FREQUENCY_MS: 1000

  initialize: ->
    @i18n = @options.i18n
    @el = @options.el or DEFAULT_EL

  render: ->
    clearInterval @interval if @interval?
    @$el = $(@el)
    @interval = setInterval (=> @updateCountdown()), @UPDATE_FREQUENCY_MS

  updateCountdown: ->
    timeLeft = @model.timeLeft()
    countdownTime = @t "js.modules.groupon-deal-timer#{CountdownTimer.Helpers.countdownTimeKey(timeLeft, true)}",
      days: timeLeft.days
      timerIcon: '<span class="icon-now"></span>'
      timestamp: CountdownTimer.Helpers.countdownTimestamp timeLeft
    @$el.html countdownTime

  t: ->
    @i18n.t.apply @i18n, arguments
